import React from 'react';

import PageTemplate from '../../components/template/PageTemplate';
import { CATEGORY_PAGE_NAME } from '../../constants/service/app/categoryConstants';
import CategoryExhibitManagementWrap from '../../views/category/exhibit/CategoryExhibitManagement';

const CategoryExhibitManagement = () => {
  return (
    <PageTemplate pageName={CATEGORY_PAGE_NAME.CATEGORY_EXHIBIT_MANAGEMENT}>
      <CategoryExhibitManagementWrap />
    </PageTemplate>
  );
};

export default CategoryExhibitManagement;
